import {Component, input} from '@angular/core';

@Component({
  selector: 'app-icon-favorite',
  imports: [],
  templateUrl: './icon-favorite.component.html'
})
export class IconFavoriteComponent {
  color = input('#4f4f4f');
}
